import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { Reveal } from "./Reveal";

function Counter({ value, prefix, suffix }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState(0);
  const num = Number(value) || 0;
  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, num, {
      duration: 2,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, num]);
  return (
    <span ref={ref} className="font-syne text-4xl font-extrabold tracking-tight text-[#F8FAFC] sm:text-5xl">
      {prefix}
      {display.toLocaleString("en-IN")}
      <span className="text-[#E3B23C]">{suffix}</span>
    </span>
  );
}

export default function Stats({ stats }) {
  return (
    <section className="border-y border-[#1E2D42] bg-[#0B131F] py-20" data-testid="stats-section">
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-x-10 gap-y-12 px-5 lg:grid-cols-4 lg:px-8">
        {(stats || []).map((s, i) => (
          <Reveal key={i} delay={i * 0.08} className="text-left">
            <div data-testid={`stat-${i}`}>
              <Counter value={s.value} prefix={s.prefix} suffix={s.suffix} />
              <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.2em] text-[#8CA0B8]">{s.label}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
